import React, { FC } from 'react';

import {
  Text,
  Input,
  FormLabel,
  FormControl,
  InputGroup,
  IconButton,
  useClipboard,
  InputLeftAddon,
  InputRightElement,
} from '@chakra-ui/react';
import { MdCheck, MdContentCopy } from 'react-icons/md';

import { useField } from 'formik';

import { UrlInputProps } from './UrlInput.props';

const UrlInputView: FC<UrlInputProps> = ({
  name,
  origin = `${window.location.origin}/cms/`,
  label = 'Website Show List',
  isReadOnly,
}) => {
  const [portalField] = useField('portal');
  const [field, meta, helpers] = useField(name);

  const url = `${origin}${field.value}`;

  const { onCopy, hasCopied } = useClipboard(url);

  return (
    <FormControl mt={8}>
      <FormLabel color="#afafaf" fontSize="14px" textTransform="capitalize">
        {label}
      </FormLabel>
      <InputGroup>
        <InputLeftAddon children={origin} />
        <Input
          isReadOnly={isReadOnly}
          value={field.value}
          isInvalid={Boolean(meta.touched && meta.error)}
          onChange={(e) => {
            helpers.setValue(e.target.value);
          }}
          onBlur={() => helpers.setTouched(true)}
          isDisabled={!portalField.value}
          placeholder="Your URL here"
        />
        <InputRightElement>
          <IconButton
            size="sm"
            isDisabled={Boolean(meta.error || !portalField.value)}
            aria-label="copy-url"
            icon={hasCopied ? <MdCheck /> : <MdContentCopy />}
            onClick={() => onCopy()}
          />
        </InputRightElement>
      </InputGroup>
      {meta.error && meta.touched && (
        <Text color="red.500" fontSize="sm">
          {meta.error}
        </Text>
      )}
    </FormControl>
  );
};

export default UrlInputView;
